export enum SmartDealPromptPayStatus {
    UnderReview = 'UnderReview',
    Approved = 'Approved',
    Rejected = 'Rejected'
}